import Box from "ds/components/Box";

type IntegrationsListWrapperProps = {
  children: React.ReactNode;
};

const IntegrationsListWrapper = ({ children }: IntegrationsListWrapperProps) => {
  return (
    <Box
      padding="x-large"
      grid
      direction="row"
      gap="x-large"
      gridTemplate="repeat(auto-fill, minmax(30rem, 1fr))"
      style={{
        gridAutoRows: "min-content",
      }}
      scrollable
      fullWidth
    >
      {children}
    </Box>
  );
};

export default IntegrationsListWrapper;
